// export const commonPoint = "https://dev.naayatrade.com:444";

// export const commonPoint = "http://13.232.36.105";

export const commonPoint = "https://dev.naayatrade.com:444";

// export const commonPoint = "http://192.168.1.118:8080";

// export const commonPoint = "http://localhost:8080";

function getCookie(name) {
  const cookieValue = document.cookie.match(
    "(^|;)\\s*" + name + "\\s*=\\s*([^;]+)"
  );
  return cookieValue ? cookieValue.pop() : "";
}

export const postData = async (endPoint = "", data, type = false) => {
  try {
    const url = commonPoint + endPoint;

    const token = getCookie("token");
    const headers = type
      ? { Authorization: `Bearer ${token}` }
      : {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

    const body = type ? data : JSON.stringify(data);

    const response = await fetch(url, {
      method: "POST",
      // credentials: "include",
      headers,
      body,
    });

    return response.json();
  } catch (error) {
    console.log("Error posting data:");
  }
};

export const getData = async (endPoint = "") => {
  try {
    const url = commonPoint + endPoint;

    const headers = { "Content-Type": "application/json" };

    const response = await fetch(url, {
      headers,
      // credentials: "include",
      method: "GET",
    });

    return response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const deleteData = async (endPoint = "", id) => {
  try {
    const url = commonPoint + endPoint;

    const response = await fetch(`${url}/${id}`, {
      method: "DELETE",
    });

    return response.json();
  } catch (error) {
    console.error("Error deleting data:", error);
    throw error;
  }
};

export const putData = async (endPoint = "", data) => {
  try {
    const url = commonPoint + endPoint;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    return response.json();
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};
